import { useLocation, useOutletContext } from 'react-router-dom'

import { TrainingMembershipsDataTableQuery } from 'generated/resources/datatable.graphql'
import compact from 'lodash/compact'

import { useDataTable } from 'modules/core/components/DataTable'

import { DeleteParticipantsModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/DeleteParticipantsModal'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

interface LocationState {
  membershipIds?: number[]
}

const isLocationState = (state: unknown): state is LocationState => {
  return (
    typeof state === 'object' &&
    state !== null &&
    ('membershipIds' in state || Object.keys(state).length === 0)
  )
}

const DeleteParticipantsWithOneCollection = () => {
  const location = useLocation()
  const selectedMembershipIds = isLocationState(location.state)
    ? (location.state.membershipIds ?? [])
    : []
  return <DeleteParticipantsModal membershipIds={selectedMembershipIds} />
}

const DeleteParticipantsWithDataTable = () => {
  const data = useDataTable<TrainingMembershipsDataTableQuery>()
  const selectedMembershipIds = compact(
    data.queryResult.data?.trainings.trainingMembershipsConnection.edges.map((membership) => {
      if (data.selectedRows.has(String(membership.node?.id))) {
        return membership.node?.id
      }
    })
  )
  return <DeleteParticipantsModal membershipIds={selectedMembershipIds} />
}

const DeleteParticipants = () => {
  const context = useOutletContext<DetailOutletContext>()

  if (!context) {
    return null
  }

  const { hasParticipantOneDataCollection } = context

  return hasParticipantOneDataCollection ? (
    <DeleteParticipantsWithOneCollection />
  ) : (
    <DeleteParticipantsWithDataTable />
  )
}

export default DeleteParticipants
